module.exports = __webpack_public_path__ + "images/4-hb22ef793f33d26419e7081f35e39ac7d.svg";